export default "__VITE_ASSET__CGKt8YhH__"